import { RootState } from '../redux/rootReducer';
import { useSelector } from 'react-redux';

const useImageData = (id?: string): string => {
  const imageDb = useSelector((state: RootState) => state.imageDb);
  if (!id) return '';
  const value = imageDb.images[id];
  return value ? value.dataUrl : '';
}

export default useImageData;
